import { Col, InputNumber, Radio, Row, Space } from "antd";
import dayjs from "dayjs";
import { t } from "i18next";
import React, { useContext, useEffect, useState } from "react";

import { RadioChangeEvent } from "antd/lib";
import { DatePicker } from "../../../../../../components/DatePicker/DatePicker";
import { Input } from "../../../../../../components/Input/Input";
import { MandatoryField } from "../../../../../../components/MandatoryField/MandatoryField";
import { Select } from "../../../../../../components/Select/Select";
import { DATE_FORMAT } from "../../../../../../core/constants";
import { IDozvolaInformacijeEditProps } from "../../../../../../modules/ministry/ministry.types";
import { ExciseLicencesContext } from "../../../../../../modules/obligee/exciseLicences/exciseLicences.context";
import {
  DozvolaTipObjekta,
  IDozvolaInformacijeProps,
} from "../../../../../../modules/obligee/exciseLicences/exciseLicences.types";
import { AkciznaMarkicaKategorijaProzivoda } from "../../../../../../modules/obligee/exciseStamps/exciseStamps.types";
import { clearNonNumericValues } from "../../../../../../utils/functions";
import style from "./LicenceDetailsEditTop.module.scss";

interface ILicenceDetailsEditTopProps {
  stateValues: IDozvolaInformacijeEditProps;
  tipDozvoleId: DozvolaTipObjekta | null;

  setInformacijeDozvole: (
    updatedState: Partial<IDozvolaInformacijeProps>
  ) => void;
}

export const LicenceDetailsEditTop: React.FC<ILicenceDetailsEditTopProps> = ({
  setInformacijeDozvole,
  tipDozvoleId,

  stateValues,
}) => {
  const [tipObjekta, setTipObjekta] = useState<DozvolaTipObjekta | null>(null);
  const { setExciseLicences } = useContext(ExciseLicencesContext);
  const getProductName = () => {
    if (stateValues.kategorijaProizvodaId === 1)
      return t("AKCIZNE_MARKICE.ALKOHOLNA_PICA");
    if (stateValues.kategorijaProizvodaId === 2)
      return t("AKCIZNE_MARKICE.DUVANSKI_PROIZVODI");
    if (stateValues.kategorijaProizvodaId === 3) return t("COMMON.KAFA");
    if (stateValues.kategorijaProizvodaId === 4)
      return t("AKCIZNE_MARKICE.DERIVATI_NAFTE");
  };

  const handleRadio = (event: RadioChangeEvent) => {
    setTipObjekta(event.target.value);
    setExciseLicences({ tipDozvole: event.target.value });
  };

  const oilInput = () => {
    if (
      stateValues.kategorijaProizvodaId ===
      AkciznaMarkicaKategorijaProzivoda.DERIVATI_NAFTE
    )
      return (
        <Row className={style.row}>
          <Col span={5}></Col>
          <Col span={5}></Col>
          <Col span={5} className="alignRight mt-5">
            <span className={style.fontSize}>
              {MandatoryField("AKCIZNE_DOZVOLE.TARIFNA_OZNAKA")}:
            </span>
          </Col>
          <Col span={5}>
            <Input
              name="tarifna-oznaka"
              className={style.fontSize}
              onChange={(e) =>
                setInformacijeDozvole({ tarifnaOznaka: e.target.value })
              }
              value={stateValues.tarifnaOznaka}
            ></Input>
          </Col>
        </Row>
      );
    return null;
  };

  useEffect(() => {
    if (!tipObjekta && !!tipDozvoleId) {
      setTipObjekta(tipDozvoleId);
    }
  }, [tipDozvoleId]);

  return (
    <Col span={24} className={style.mainContainer}>
      <Row className={style.row}>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>
            {t("AKCIZNE_DOZVOLE.TIP_OBJEKTA")}:
          </span>
        </Col>
        <Col span={18}>
          <Radio.Group value={tipObjekta} onChange={handleRadio}>
            <Radio value={DozvolaTipObjekta.SKLADISTE}>
              {t("SETTINGS_OBJECTS.AKCIZNO_SKLADISTE")}
            </Radio>
            <Radio value={DozvolaTipObjekta.PROIZVODNJA_SA_SKLADISTEM}>
              {t("AKCIZNE_DOZVOLE.AKCIZNO_SKLADISTE_PROIZVODNI_POGON")}
            </Radio>
          </Radio.Group>
        </Col>
      </Row>
      <Row className={style.row}>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>
            {t(
              "AKCIZNE_DOZVOLE.VRSTA_AKCIZNOG_PROIZVODA_KOJI_CE_SE_PROIZVODITI_I_SMESTATI_U_SKLADISTE"
            )}
            :
          </span>
        </Col>
        <Col span={5}>
          <Select
            className={style.fontSize}
            disabled
            placeholder={getProductName()}
            name="vrsta-akciznog-proizvoda"
          />
        </Col>
        {stateValues.kategorijaProizvodaId ===
        AkciznaMarkicaKategorijaProzivoda.DUVAN ? (
          <>
            <Col span={5} className="alignRight">
              <span className={style.fontSize}>
                {tipObjekta === DozvolaTipObjekta.SKLADISTE
                  ? MandatoryField(
                      "AKCIZNE_DOZVOLE.KOLICINA_USKLADISTENIH_PROIZVODA_NA_ZALIHAMA_U_PROSTORU"
                    )
                  : t(
                      "AKCIZNE_DOZVOLE.KOLICINA_USKLADISTENIH_PROIZVODA_NA_ZALIHAMA_U_PROSTORU"
                    )}
                :
              </span>
            </Col>
            <Col span={5} className="pb-15">
              <Space.Compact style={{ width: "100%" }}>
                <InputNumber
                  onChange={(value) =>
                    setInformacijeDozvole({
                      kolicinaDuvanaKg: value,
                    })
                  }
                  min={0}
                  placeholder={"kg"}
                  className={`${style.fontSize}`}
                  style={{ width: "40%" }}
                  step={0.1}
                  value={stateValues.kolicinaDuvanaKg}
                  name="uskladistenih-kolicina-duvana-kg"
                  onKeyDown={(event) => clearNonNumericValues(event, ["."])}
                />
                <InputNumber
                  min={0}
                  className={`${style.fontSize}`}
                  style={{ width: "60%" }}
                  placeholder={t("PLACEHOLDERS.KOMADI")}
                  onChange={(value) =>
                    setInformacijeDozvole({
                      kolicinaPojedinacnihPakovanjaKomadi: value,
                    })
                  }
                  value={stateValues.kolicinaPojedinacnihPakovanjaKomadi}
                  name="uskladistenih-kolicina-pojedinacnih-pakovanja-komadi"
                  onKeyDown={clearNonNumericValues}
                />
              </Space.Compact>
            </Col>
            <Col span={5} className="alignRight"></Col>
            <Col span={5} className="alignRight"></Col>
            <Col span={5} className="alignRight">
              <span className={style.fontSize}>
                {tipObjekta === DozvolaTipObjekta.SKLADISTE
                  ? MandatoryField("AKCIZNE_DOZVOLE.PROSECAN_MESECNI_RASHOD")
                  : t("AKCIZNE_DOZVOLE.PROSECAN_MESECNI_RASHOD")}
                :
              </span>
            </Col>
            <Col span={5}>
              <Space.Compact style={{ width: "100%" }}>
                <InputNumber
                  onChange={(value) =>
                    setInformacijeDozvole({
                      prosecnaKolicinaDuvanaKg: value,
                    })
                  }
                  value={stateValues.prosecnaKolicinaDuvanaKg}
                  placeholder={"kg"}
                  className={`${style.fontSize} w-40`}
                  step={0.1}
                  name="prosecna-kolicina-duvana-kg"
                  onKeyDown={(event) => clearNonNumericValues(event, ["."])}
                />
                <InputNumber
                  onChange={(value) =>
                    setInformacijeDozvole({
                      prosecnaKolicinaPojedinacnihPakovanjaKomadi: value,
                    })
                  }
                  value={
                    stateValues.prosecnaKolicinaPojedinacnihPakovanjaKomadi
                  }
                  placeholder={t("PLACEHOLDERS.KOMADI")}
                  className={`${style.fontSize} w-60`}
                  name="prosecna-kolicina-pojedinacnih-pakovanja-komadi"
                />
              </Space.Compact>
            </Col>
          </>
        ) : (
          <>
            <Col span={5} className="alignRight">
              <span className={style.fontSize}>
                {tipObjekta === DozvolaTipObjekta.SKLADISTE
                  ? MandatoryField(
                      "AKCIZNE_DOZVOLE.KOLICINA_USKLADISTENIH_PROIZVODA_NA_ZALIHAMA_U_PROSTORU"
                    )
                  : t(
                      "AKCIZNE_DOZVOLE.KOLICINA_USKLADISTENIH_PROIZVODA_NA_ZALIHAMA_U_PROSTORU"
                    )}
                :
              </span>
            </Col>
            <Col span={5} className="pb-15">
              <InputNumber
                min={0}
                className={`${style.fontSize} w-100`}
                onChange={(value) =>
                  setInformacijeDozvole({
                    kolicinaUskladistenihProizvoda: value,
                  })
                }
                value={stateValues.kolicinaUskladistenihProizvoda}
                name="kolicina-uskladistenih-proizvoda-na-zalihama"
                onKeyDown={clearNonNumericValues}
              />
            </Col>
            <Col span={5}></Col>
            <Col span={5}></Col>
            <Col span={5} className="alignRight pt-6">
              <span className={style.fontSize}>
                {tipObjekta === DozvolaTipObjekta.SKLADISTE
                  ? MandatoryField("AKCIZNE_DOZVOLE.PROSECAN_MESECNI_RASHOD")
                  : t("AKCIZNE_DOZVOLE.PROSECAN_MESECNI_RASHOD")}
                :
              </span>
            </Col>
            <Col span={5}>
              <InputNumber
                min={0}
                className={`${style.fontSize} w-100`}
                onChange={(value) =>
                  setInformacijeDozvole({
                    prosecanMesecniRashod: value,
                  })
                }
                value={stateValues.prosecanMesecniRashod}
                name="prosecan-mesecni-rashod"
              />
            </Col>
          </>
        )}
      </Row>
      <Row className={style.row}>
        <Col span={2}></Col>
        <Col span={8} className={style.subtitle}>
          <span className={style.fontSize}>
            {t(
              "AKCIZNE_DOZVOLE.ADRESA_GDE_SE_OBAVLJA_PROIZVODNJA_AKCIZNOG_PROIZVODA"
            )}
          </span>
        </Col>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>
            {MandatoryField(
              "AKCIZNE_DOZVOLE.NACIN_OTPREMANJA_AKCIZNIH_PROIZVODA"
            )}
            :
          </span>
        </Col>
        <Col span={5}>
          <Input
            onChange={(e) =>
              setInformacijeDozvole({
                nacinOtpremanja: e.target.value,
              })
            }
            value={stateValues.nacinOtpremanja}
            className={style.fontSize}
            name="nacin-otpremanja-akciznih-proizvoda"
          />
        </Col>
      </Row>
      <Row className={style.row}>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>
            {MandatoryField("AKCIZNE_DOZVOLE.ULICA_I_BROJ")}:
          </span>
        </Col>
        <Col span={5}>
          <Space.Compact>
            <Input
              onChange={(e) =>
                setInformacijeDozvole({
                  ulicaProizvodnje: e.target.value,
                })
              }
              value={stateValues.ulicaProizvodnje}
              placeholder={t("PLACEHOLDERS.ULICA")}
              className={`${style.fontSize} w-75`}
              name="ulica"
            />
            <Input
              onChange={(e) =>
                setInformacijeDozvole({
                  brojUliceProizvodnje: e.target.value,
                })
              }
              value={stateValues.brojUliceProizvodnje}
              placeholder={t("PLACEHOLDERS.BROJ")}
              className={`${style.fontSize} w-25`}
              name="broj"
            />
          </Space.Compact>
        </Col>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>
            {MandatoryField("AKCIZNE_DOZVOLE.PODATAK_O_MERNIM_UREDJAJIMA")}:
          </span>
        </Col>
        <Col span={5}>
          <Input
            onChange={(e) =>
              setInformacijeDozvole({
                podatakOMernimUredjajima: e.target.value,
              })
            }
            value={stateValues.podatakOMernimUredjajima}
            className={style.fontSize}
            name="podatak-merni-uredjaji"
          />
        </Col>
      </Row>
      <Row className={style.row}>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>
            {MandatoryField("AKCIZNE_DOZVOLE.POSTANSKI_BROJ")}:
          </span>
        </Col>
        <Col span={5}>
          <Input
            onChange={(e) =>
              setInformacijeDozvole({
                postanskiBrojProizvodnje: e.target.value,
              })
            }
            value={stateValues.postanskiBrojProizvodnje}
            className={style.fontSize}
            name="postanski-broj"
          />
        </Col>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>
            {MandatoryField(
              "AKCIZNE_DOZVOLE.BROJ_RESENJA_NADLEZNOG_ORGANA_U_POGLEDU_TEHNICKE_OPREMLJENOSTI"
            )}
            :
          </span>
        </Col>
        <Col span={5}>
          <Input
            onChange={(e) =>
              setInformacijeDozvole({
                brojResenja: e.target.value,
              })
            }
            value={stateValues.brojResenja}
            className={style.fontSize}
            name="broj-resenja"
          />
        </Col>
      </Row>
      <Row className={style.row}>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>
            {MandatoryField("AKCIZNE_DOZVOLE.MESTO")}:
          </span>
        </Col>
        <Col span={5}>
          <Input
            onChange={(e) =>
              setInformacijeDozvole({
                mestoProizvodnje: e.target.value,
              })
            }
            value={stateValues.mestoProizvodnje}
            className={style.fontSize}
            name="mesto"
          />
        </Col>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>
            {MandatoryField(
              "AKCIZNE_DOZVOLE.DATUM_RESENJA_NADLEZNOG_ORGANA_U_POGLEDU_TEHNICKE_OPREMLJENOSTI"
            )}
            :
          </span>
        </Col>
        <Col span={5}>
          <DatePicker
            format={DATE_FORMAT}
            onChange={(value) =>
              setInformacijeDozvole({
                datumResenjaNadleznogOrgana: value,
              })
            }
            value={dayjs(stateValues.datumResenjaNadleznogOrgana)}
            allowClear={false}
            placeholder={t("PLACEHOLDERS.DATUM")}
            className={style.fontSize}
            name="resenje-nadleznog-organa-edit"
          />
        </Col>
      </Row>
      {oilInput()}
    </Col>
  );
};
